<template>
    <transition name="slide-fade">
        <div class="modal" :class="{'open' : open}" v-if="open" data-cy="modal_verify_code">
            <div class="modal-content">
                <div class="bg-white w-full p-4">
                    <div class="w-40 h-48 mx-auto -mt-20">
                        <img :src="initImageUrls()" />
                    </div>
                    <div class="text-a-blue-001b73 text-center">
                        <div class="font-medium text-20">{{lbl.detail.verify.title}}</div>
                        <div class="font-regular text-16 mt-2" v-html="getPointMsg()"></div>
                    </div>
                    <div class="px-2 pb-3 pt-4">
                        <InputText
                            v-model:inputValue="code"
                            data-cy="input_verify_code"
                            :errorInfo="errorInfo[0]"
                            :isShowError="isShowError"
                            :inputLbl="lbl.detail.verify.verify_code"
                            @update:inputValue="verifyCode($event)"
                            @input="onChange()" />
                        <div v-if="error || isShowError" class="-mt-3 text-a-red-ff4d4d">
                            <div>{{msgError()}}</div>
                        </div>
                    </div>
                    <div class="grid grid-cols-2 gap-2 px-1 pb-1">
                        <div>
                            <button class="w-full btn bg-a-white-ffffff border border-a-blue-2140a6 font-bold text-a-blue-2140a6 text-18 rounded-sm py-1" data-cy="btn_verify_code_cancel" @click="clickCancel()">
                                {{btnCancel}}
                            </button>
                        </div>
                        <div>
                            <button class="w-full btn bg-a-blue-f2f5ff text-a-blue-c2cdf2 font-bold text-18 rounded-sm py-1 " data-cy="btn_verify_code_confirm_disabled" v-if="!code">
                                {{lbl.detail.verify.btn_confirm}}
                            </button>
                            <button class="w-full btn bg-a-blue-2140a6 text-a-white-ffffff font-bold text-18 rounded-sm py-1 " data-cy="btn_verify_code_confirm" @click="clickOk()" v-else>
                                {{lbl.detail.verify.btn_confirm}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import Util from "@/helper/Utility.js";
import { FormHelper } from "@/helper/FormHelper.js";
//mixin
import LocaleMixin from "@/mixin/LocaleMixin.js";
// import { CampaignType } from "@/helper/StaticValue.js";
//component
import InputText from '@/components/Input/label/InputText.vue';
import ConfigManager from "@/config/ConfigManager.js";

export default {
    name: "VerifyCodeModal",
    mixins: [LocaleMixin],
    components: {
        InputText
    },
    props: {
        controller: Object,
    },
    data: function() {
        return {
            open: false,

            type: null,
            campaign: null,
            btnOk: '',
            btnCancel: '',
            busModal: null,
            code: null,
            errorInfo: FormHelper.genErrorInfo(1),
            isShowError: false,
            error: null
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    watch: {
        '$route.path': function() {
            if (this.open) {
                this.hide();
            }
        },
    },
    methods: {
        show: function(config) {
            this.campaign = config.campaign;
            this.btnOk = config.btnOk;
            this.btnCancel = config.btnCancel;
            this.error = config.error;

            if (Util.isEmptyStr(this.btnOk)) {
                this.btnOk = this.lbl.confirm_redeem.confirm;
            }
            if (Util.isEmptyStr(this.btnCancel)) {
                this.btnCancel = this.lbl.confirm_redeem.cancel;
            }
            if (this.error) {
                this.validate();
                this.isShowError = true;
            }

            this.tracking.screenName('campaign_input_code');
            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickOk: function () {
            this.tracking.event('campaign_input_code', 'click_input_code_confirm', this.campaign.id, null);

            if (this.code == null) {
                this.isShowError = true;
                return
            } else {
                this.isShowError = false
                this.hide();
                return this.controller.sendCallbackOk(this.code);
            }

        },
        clickCancel: function() {
            this.tracking.event('campaign_input_code', 'click_input_code_cancel', this.campaign.id, null);

            this.hide();
            this.controller.sendCallbackCancel();
            this.code = null;
            this.error = false;
            this.isShowError = false;
        },
        getPointMsg: function() {
            var point = this.campaign.pointPerUnit;
            this.text = Util.stringFormat(this.lbl.detail.verify.msg, point);
            return this.text;
        },
        verifyCode: function(code) {
            this.code = code;
        },
        validate: function() {
            return FormHelper.validate(this.errorInfo);
        },
        onChange: function(){
            this.tracking.event('campaign_input_code', 'click_input_code', this.campaign.id, null);
        },
        msgError: function() {
            const { code, id, message } = this.error;
            const msgs = this.lbl.detail.verify.verify_code;

            if (code == 404) return msgs.invalid;

            if (code == 409) {
                if (id == 2021) {
                    if (['Code was used', 'Used/Expired'].includes(message)) return msgs.use_expire;
                    if (['Campaign is invalid', 'no permission to use'].includes(message)) return msgs.invalid;
                }
                
                if (id == 409 && message == 'no permission to use') {
                    return msgs.invalid;
                }
            }

            return message;
        },
        initImageUrls: function() {
            var appId = ConfigManager.getAppId();
            var baseUrl = ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/`;
            
            // images loading
            return baseUrl + 'image/modalconfirm/img-fish-confirm.png';
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    @import "@/style/modal.scss";
    .modal {
        @extend %modal;
        overflow: auto;
        .modal-content {
            width: 420px;
            overflow: unset;

            @media(max-height: 500px){
                margin-top: 80px;
            }

            @include mobile {
                width: 100%;
                padding: 20px;
            }
        }
        .btn {
            height: 50px;
        }
    }
</style>
